import {makeStyles} from "tss-react/mui";
import {needUpgradeBackground} from "../UpgradeAdornment";

export const useCustomSelectStyles = makeStyles()((theme, {needUpgrade}) => ({
  primary: {
    background: needUpgrade ? needUpgradeBackground(theme) : undefined,
  },
  spaceTop: {
    marginTop: theme.spacing(2),
  },
}));

export const useCustomTextFieldStyles = makeStyles()((theme, {needUpgrade}) => ({
  primary: {
    background: needUpgrade ? needUpgradeBackground(theme) : undefined,
  },
}));

export const useFormBuilderStyles = makeStyles()((theme) => ({
  buttonGroup: {
    display: "flex",
  },
  stickySubmit: {
    position: "sticky",
    bottom: 0,
    zIndex: 15,
    paddingTop: theme.spacing(1),
    backgroundColor: theme.palette.background.default,
    borderImage: `linear-gradient(to right, ${theme.palette.divider}, transparent) 0.8`,
    borderTop: "1px outset",
  },
  fieldItem: {
    overflow: "visible",
  },
  fieldBox: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(2),
    overflow: "visible",
  },
  quickButton: {
    marginLeft: theme.spacing(1),
  },
  addTaskDialog: {
    minWidth: theme.spacing(100),
    minHeight: theme.spacing(50),
  },
  closeDialog: {
    position: "absolute",
    right: theme.spacing(2),
    "&:hover": {
      backgroundColor: "unset",
    },
  },
  clearSpacing: {
    margin: 0,
    padding: 0,
  },
  aiTemplateLoading: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    minHeight: 300,
    gap: theme.spacing(2),
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: theme.shape.borderRadius,
  },
}));

export const useCustomAutocompleteStyles = makeStyles()((theme, {margin}) => ({
  span: {
    marginBottom: margin?.bottom ? theme.spacing(margin.bottom) : undefined,
    marginLeft: margin?.left ? theme.spacing(margin.left) : undefined,
    marginRight: margin?.right ? theme.spacing(margin.right) : undefined,
    marginTop: margin?.top ? theme.spacing(margin.top) : undefined,
    display: "block",
  },
  inputRoot: {
    "& .MuiAutocomplete-input": {
      minWidth: theme.spacing(7.4),
    },
    "&[class*='MuiFilledInput-root']": {
      padding: ".5rem",
      borderRadius: 0,
    },
  },
}));

export const useCustomDateTimePickerStyles = makeStyles()((theme, {error} = {}) => ({
  inputBox: {
    fieldset: {
      borderColor: error ? theme.palette.error.main : undefined,
    },
  },
}));

export const useAgentFieldHighlightStyles = makeStyles()((theme) => ({
  root: {
    position: "relative",
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: theme.palette.primary.main,
      borderWidth: 2,
    },
    "& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline": {
      borderColor: theme.palette.primary.main,
      borderWidth: 2,
    },
    "& .sun-editor": {
      outline: `2px solid ${theme.palette.primary.main}`,
      outlineOffset: 2,
      borderRadius: theme.shape.borderRadius,
    },
    "& .query-builder > .group-container > .group-or-rule": {
      border: `2px solid ${theme.palette.primary.main}`,
    },
  },
  indicator: {
    position: "absolute",
    left: -22,
    top: "50%",
    color: theme.palette.primary.main,
    display: "flex",
    alignItems: "center",
    zIndex: 1,
  },
}));
